import {useParams} from "react-router-dom";
import {useState} from "react";
import {
  Breadcrumb,
  Card,
  Col,
  Row,
  Typography,
} from "antd";
import TableOneXMLNewStories from "../../components/TableOneXMLNewStories";
import TableTwoXMLNewStories from "../../components/TableTwoXMLNewStories";
import {useTranslation} from "react-i18next";

const { Title } = Typography;

const CreateXMLNewStories = () => {

  const { key } = useParams();
  const [reload, setReload] = useState<any>(0);
  const { t } = useTranslation();

  return(
    <Row justify='center'>
      <Col span={24} className='p-1'>
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <Breadcrumb>
              <Breadcrumb.Item>SCUAPP</Breadcrumb.Item>
              <Breadcrumb.Item>{key}</Breadcrumb.Item>
            </Breadcrumb>
            <Title level={3}>{t('createXmlNewStories')}</Title>
          </Col>
          <Col span={24}>
            <Row gutter={[10, 30]}>
              <Col span={24}>
                <Card className='border-radius'>
                  <TableOneXMLNewStories setReload={setReload} />
                </Card>
              </Col>
              <Col span={24}>
                <Card className='border-radius'>
                  <TableTwoXMLNewStories reload={reload} />
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default CreateXMLNewStories;
